<template>
  <div class="pages permissions">
    <div class="container">
      <h1>设备权限清单</h1>
      <table class="sdk-table">
        <thead>
          <tr>
            <th>权限名称</th>
            <th>权限功能说明</th>
            <th>使用场景或目的</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>读取/写入外置存储</td>
            <td>读取和写入设备存储空间内的数据</td>
            <td>用户保存、读取用户草稿、笔刷、保存的图片、文件等信息</td>
          </tr>
          <tr>
            <td>读取/写入相册</td>
            <td>读取和写入设备相册中的内容</td>
            <td>用于导入相册图片进行绘画创作，或保存作品图片到相册等功能</td>
          </tr>
          <tr>
            <td>相机</td>
            <td>使用相机拍摄照片</td>
            <td>用于拍摄照片设置用户头像、创建画题选择封面、创建创作点子选择封面等功能</td>
          </tr>
          <tr>
            <td>麦克风</td>
            <td>使用麦克风录制音频</td>
            <td>用于IM私聊发送语音信息</td>
          </tr>
          <tr>
            <td>读取手机/电话状态</td>
            <td>获取IMEI和MAC等设备识别信息</td>
            <td>用户完成设备绑定，防止账号被盗，优化账号登录设备管理</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Persissions",
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
.permissions {
  .container {
    h1 {
      font-size: 24px;
    }
    .top__desc {
      font-size: 14px;
      text-indent: 2em;
      line-height: 2;
    }
    h6.subtitle {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .third-url-list {
      > a {
        display: block;
      }
    }
    li {
      > h2 {
        display: inline;
        font-size: 14px;
        font-weight: bold;
        + ol {
          margin-top: 15px;
        }
      }
      p {
        margin-top: 1em;
        margin-bottom: 0;
      }
      a {
        color: #1989fa;
        text-decoration: none;
      }
    }
  }
  .sdk-table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;
    tr {
      > th {
        padding: 8px 10px;
        border-bottom: 1px solid #d9d9db;
        &:first-child{
          width: 80px;
        }
      }
    }
    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: center;
    }
  }
}
</style>
